import { HOTELS_UPSTREAM_BASE_URL } from '@/src/constants/hotels'
import { getSelectedCurrency } from '@/src/redux/slices/currencySlice'
import { setHotelUpstreamHeaders } from '@/src/utils/hotels'
import { selectCurrentUser } from '@/src/redux/slices/authSlice'
import type { RootState } from '@/src/redux/rootReducer'
import { fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Shared base query for every Flyin hotels endpoint: same-origin upstream base plus the
// currency/`new-native-app` header wiring. `timeout` is opt-in — confirmation bounds a
// pid that never resolves; the others rely on the default.
export const createHotelBaseQuery = (options?: { timeout?: number }) =>
    fetchBaseQuery({
        baseUrl: HOTELS_UPSTREAM_BASE_URL,
        ...(options?.timeout != null ? { timeout: options.timeout } : {}),
        prepareHeaders: (headers, { getState }): Headers => {
            const state = getState() as RootState
            return setHotelUpstreamHeaders(headers, getSelectedCurrency(state), selectCurrentUser(state).email)
        }
    })
